import { render, staticRenderFns } from "./PayrollCode.vue?vue&type=template&id=4b5d604f&scoped=true&"
import script from "./PayrollCode.vue?vue&type=script&lang=js&"
export * from "./PayrollCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5d604f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5d604f')) {
      api.createRecord('4b5d604f', component.options)
    } else {
      api.reload('4b5d604f', component.options)
    }
    module.hot.accept("./PayrollCode.vue?vue&type=template&id=4b5d604f&scoped=true&", function () {
      api.rerender('4b5d604f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Spaiectacle/PayrollCode.vue"
export default component.exports